import React from 'react';
import './index.scss';
import emailIcon from '../../assets/email.png';
import successIcon from '../../assets/v1.png';
import { Dialog } from '../../components/Dialog';
import * as api from '../../services/api';
import en from '../../locales/en-US.json';
import zh from '../../locales/zh-Hans.json';
import urlparser from 'urlparser';
import { Helmet } from 'react-helmet';
import { message } from 'antd';
import QRCode from 'qrcode.react';
import ReactGA from 'react-ga';

const wx = require('weixin-js-sdk');


export interface IInviteProps {
  logo: string,
  inviterId: string;
  trailId: string;
  contentId: string;
  source:string;
  recordShare:string;
  qrcode?: string;
  state:string;
}

interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo: string;
  inviterId: string;
  trailId: string;
  contentId: string;
  sourceTitle: string,
  gallery: string,
  id: string,
  type: string,
  link: string,
  state:string
}

interface IParams {
  jwt: string;
  isWeChat: string;
  weChatButtonUrl: string;
  logo: string;
  inviterId: string;
}

export interface ITrialRes {
  time: number;
  error?: string;
  body?: {
    days: number;
  };
}

export class ContentShareRegister extends React.Component<IInviteProps, IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo: '',
    inviterId: '',
    trailId: '',
    contentId: '',
    sourceTitle: '',
    gallery: '',
    id: '',
    type: '',
    link: '',
    state:''
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    let path = url.path.base;
    if (path.split('/')[1] === 'en') {
      this.setState({
        lang: 'en-US'
      });
    }
    let title = '';
    switch (path) {
      case 'trial/activity':
      case 'trial/activity-kw':
        title = 'iSlide VIP体验活动';
        break;
      case 'trial/bookActivity':
        title = 'iSlide 书籍活动';
        break;
      default:
        title = 'iSlide VIP体验活动';
        break;
    }
    this.setState({
      title
    });

    if (path === 'trial/activity-kw') {
      let custom = require('../../assets/kw.png');
      this.setState({
        custom
      });
    }
  }

  async componentDidMount() {
    this.setState(
      {
        trailId: this.props.trailId,
        logo: this.props.logo,
        inviterId: this.props.inviterId,
        contentId: this.props.contentId,
        state:this.props.state
      });

    if (this.props.contentId) {
      let detailData = await api.contentShareDetail(this.props.contentId);
      // let data = await api.contentShareItems(this.props.contentId, this.props.inviterId);
      if (!detailData.error) {
        // let link:any =''
        // if(data){
        //   data.body.map((item:any)=>{
        //     if(item.isQrCode){
        //       link=item.link
        //     }
        //   })
        // }
        if (!sessionStorage.getItem(this.props.contentId)&&this.props.recordShare) {
          let recordData = await api.recordShare(this.props.contentId, this.props.inviterId ? {
            type: 'wechat',
            userId: this.props.inviterId,
            source:this.props.source?this.props.source:null
          } : { type: 'wechat',source:this.props.source?this.props.source:null });
          if (!recordData.error) {
            sessionStorage.setItem(this.props.contentId, 'true');
          }
        }
        this.setState({
          // link:link,
          sourceTitle: detailData.body && detailData.body.title,
          gallery: detailData.body && detailData.body.gallery,
          id: detailData.body && detailData.body.id,
          type: detailData.body && detailData.body.type
        });
      } else {
        if (detailData.error) {
          message.error(detailData.error);
        }
      }
    }
    if (this.props.qrcode) {
      this.weChatShare();
    }
  }

  weChatShare = async () => {
    let data = await api.getShareDetail(window.location.href);
    let config = data && data.body && data.body.config ? data.body.config : {};
    await wx.config(config);
    let shareConfig = {
      title: '升职加薪从做好一张PPT开始', // 分享标题
      desc: '30万+专业级PPT素材库，减少90%PPT设计时间，百万职场人的共同选择', // 分享描述
      imgUrl: 'https://share.islide.cc/images/invite/74ffdb7a259b450c3d1652349d12c6729a79cdd3.png', // 分享描述\n', // 分享图标
      success: () => {
      },
      cancel: () => {
      }
    };
    await wx.ready(function() {
      wx.onMenuShareAppMessage(shareConfig);
      wx.onMenuShareTimeline(shareConfig);
      wx.onMenuShareQZone(shareConfig);
      wx.onMenuShareWeibo(shareConfig);
      wx.onMenuShareQQ(shareConfig);
    });
    await wx.error(function(e: any) {
      console.log(e);
    });
  };

  handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      email: e.target.value
    });
  }

  async handleSubmit() {
    if (!this.state.email.trim()) {
      return this.setState({
        errMsg: '邮箱必填',
        showErr: true
      });
    }

    this.setState({
      disabled: true
    });

    let result: ITrialRes = await api.register(
      this.state.email.trim(),
      this.state.trailId,
      this.state.state,
      this.state.inviterId
    );
    if (result.error) {
      return this.setState({
        disabled: false,
        errMsg: result.error,
        showErr: true
      });
    }
    if (result.body) {
      ReactGA.pageview(window.location.pathname+`/${result.body.days}days/email/success`);
      this.setState({
        time: `${result.body.days}`,
        showDialog: true
      });
    }
  }

  handleWechat = () => {
    if (!this.state.buttonUrl) {
      return;
    }
    // window.location.href = this.state.buttonUrl;
    window.open(this.state.buttonUrl);
  };

  render() {
    const { sourceTitle, gallery, id, type, link } = this.state;
    return (
      <div id="content-share-register-page">
        <section id="header">
          <div className="custom">
            <h3>这里有个PPT文档</h3>
            <h2>推荐给你!</h2>
          </div>
        </section>
        <section id="content">
          <h3>{sourceTitle}</h3>
          <img className={'content-share-register-source-img'} src={gallery} alt=""/>
          <p className={'content-share-register-source-id'}>资源ID：{id}</p>
          <p className={'content-share-register-source-type'}>iSlide【{type}】搜索资源ID获取</p>
          {
            this.props.qrcode
              ?
              <div className="content-share-register-qr-code">
                <img className="content-share-register-qr-code-img" src={require('../../assets/successImg.png')}
                     alt=""/>
                {/* <QRCode value={this.props.qrcode}
                    size={100}/> */}
                <img style={{ width: '2.66667rem', height: '2.66667rem' }} src={this.props.qrcode} alt=""/>
              </div>
              :
              <section id="form">
                <div className="form">
                  <p className="err-message">{this.state.errMsg}</p>
                  <div className="form-input">
                    <img className="email-icon" src={emailIcon} alt="email"/>
                    <input
                      onChange={this.handleEmailChange.bind(this)}
                      placeholder="填写邮箱获取iSlide VIP会员"
                    />
                  </div>
                  <button
                    onClick={this.handleSubmit.bind(this)}
                    disabled={this.state.disabled}
                  >
                    立即体验
                  </button>
                </div>
              </section>
          }
          {
            this.props.qrcode
              ?
              <p className="content-share-register-intro-one">扫码免费获取iSlide会员</p>
              : null
          }
          {
            this.props.qrcode
              ?
              <p className="content-share-register-intro-two">30万+模板素材一键导入PPT</p>
              : null
          }
        </section>

        <Dialog
          visible={this.state.showDialog}
          onClose={() => {
            this.setState({
              showDialog: false,
              disabled: false
            });
          }}
        >
          <div className="dialog-success">
            <img src={successIcon} alt="success"/>
            <p className="message">账号开通成功!</p>
            <section className="footer">
              <p className="remark">您的体验会员时长为{this.state.time}天，请及时登录使用</p>
              <p className="remark" style={{ marginTop: '0.2rem' }}>
                请查收以便于及时激活您的账号
              </p>
              <p className="remark" style={{ marginBottom: '0.4rem' }}>
                (可能误判为垃圾邮件)
              </p>
            </section>
          </div>
        </Dialog>
      </div>
      //{' '}
    );
  }
}
